import urls from '../api_urls/announcement'
import { _post } from '@/axios/request'

// get announcement table
export function getTableData (params) {
  return _post(urls.GET_TABLE_LIST, params)
}

// add&save announcement detail
export function saveDetail (params) {
  return _post(urls.SAVE_DETAIL, params)
}

// update announcement detail
export function updateDetail (params) {
  return _post(urls.UPDATE_DETAIL, params)
}

// get announcement detail
export function getDetail (params) {
  return _post(urls.GET_DETAIL, params)
}

// update announcement status
export function updateStatus (params) {
  return _post(urls.UPDATE_STATUS, params)
}

// get announce when login or refresh
export function getAnnounce () {
  return _post(urls.GET_ANNOUNCE)
}



// WEBPACK FOOTER //
// ./src/axios/api/announcement.js